// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"SendResultsByEmail_iconSync__rF6du","fa-spin":"SendResultsByEmail_fa-spin__3v1A_","accordionHeader":"SendResultsByEmail_accordionHeader__UQK-K"};